import { parseCurrency } from 'components/Widget/shared/currency';
import {
  ANNUAL_SALARY_MAX_ERROR,
  ANNUAL_SALARY_MIN_ERROR,
  HOURLY_WAGE_MAX_ERROR,
  HOURLY_WAGE_MIN_ERROR,
  MAX_ANNUAL_SALARY,
  MAX_HOURLY_WAGE,
  MAX_WEEKLY_HOURS,
  PAY_FREQUENCY_ERROR,
  WEEKLY_HOURS_ERROR,
} from './constants';
import type { PaycheckFormErrors, PaycheckValidationInput } from './types';

/** `parseCurrency` reads blank and non-numeric input as 0, so a strict zero floor rejects those too. */
const isPositive = (raw: string): boolean => parseCurrency(raw) > 0;

/** Names the bound that failed, so an over-limit amount is not told to be "greater than $0". */
const moneyError = (raw: string, maximum: number, minError: string, maxError: string): string | undefined => {
  if (!isPositive(raw)) return minError;

  return parseCurrency(raw) > maximum ? maxError : undefined;
};

/** The hidden pay branch keeps whatever was last typed, so validating it would block Calculate invisibly. */
export const validatePaycheckForm = (input: PaycheckValidationInput): PaycheckFormErrors => {
  const errors: PaycheckFormErrors = {};

  if (input.payFrequency === null) errors.payFrequency = PAY_FREQUENCY_ERROR;

  if (input.payType === 'salary') {
    const annualSalary = moneyError(
      input.annualSalary,
      MAX_ANNUAL_SALARY,
      ANNUAL_SALARY_MIN_ERROR,
      ANNUAL_SALARY_MAX_ERROR,
    );

    if (annualSalary) errors.annualSalary = annualSalary;

    return errors;
  }

  const hourlyWage = moneyError(input.hourlyWage, MAX_HOURLY_WAGE, HOURLY_WAGE_MIN_ERROR, HOURLY_WAGE_MAX_ERROR);

  if (hourlyWage) errors.hourlyWage = hourlyWage;

  if (!isPositive(input.weeklyHours) || parseCurrency(input.weeklyHours) > MAX_WEEKLY_HOURS) {
    errors.weeklyHours = WEEKLY_HOURS_ERROR;
  }

  return errors;
};
